import React from 'react';
import { motion } from 'framer-motion';

const ScrollingWords = () => {
  const message = `Accomplished and passionate practitioner of the FemDom arts. Mistress Diva demands excellence, submission, and unwavering devotion. Experience true Domination. `;

  return (
    <div className='relative overflow-hidden bg-colour2 text-colour1 py-3 border-t-2 border-b-2 border-colour7 border-solid'>
      <motion.div
        className='whitespace-nowrap flex space-x-2 text-lg font-medium font-argesta tracking-wide'
        animate={{ x: ['0%', '-100%'] }}
        transition={{
          repeat: Infinity,
          ease: 'linear',
          duration: 25,
        }}
      >
        {/* Repeat the message a few times to create the loop */}
        {[...Array(3)].map((_, i) => (
          <span key={i}>{message}</span>
        ))}
      </motion.div>
    </div>
  );
};

export default ScrollingWords;
